export default function ServiceImport({ size = 96 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 96 96" fill="none" aria-hidden="true">
      <path
        d="M16 70 L48 78 L80 70 L80 38 L48 30 L16 38 Z"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <path d="M16 38 L48 46 L80 38 M48 46 V78" stroke="currentColor" strokeWidth="1.25" />
      <path d="M48 12 V26 M42 20 L48 26 L54 20" stroke="#54B53C" strokeWidth="1.25" />
    </svg>
  );
}
